var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCells(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57617 21H2.57617V17H6.57617V21ZM11.5762 21H7.57617V17H11.5762V21ZM16.5762 21H12.5762V17H16.5762V21ZM21.5762 21H17.5762V17H21.5762V21ZM6.57617 16H2.57617V12H6.57617V16ZM11.5762 16H7.57617V12H11.5762V16ZM16.5762 16H12.5762V12H16.5762V16ZM21.5762 16H17.5762V12H21.5762V16ZM6.57617 11H2.57617V7H6.57617V11ZM11.5762 11H7.57617V7H11.5762V11ZM16.5762 11H12.5762V7H16.5762V11ZM21.5762 11H17.5762V7H21.5762V11ZM6.57617 6H2.57617V2H6.57617V6ZM11.5762 6H7.57617V2H11.5762V6ZM16.5762 6H12.5762V2H16.5762V6ZM21.5762 6H17.5762V2H21.5762V6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCells);
export default __webpack_public_path__ + "static/media/cells.27eb144918f91dbd946ee0f763752bf9.svg";
export { ForwardRef as ReactComponent };